import { formatDate } from "@/shared/lib/date-time";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { RevenueTrendItemDTO } from "../api/client";

type RevenueTrendTableProps = {
  isLoading: boolean;
  data: RevenueTrendItemDTO[];
};

export function RevenueTrendTable({ isLoading, data }: RevenueTrendTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[120px]">ວັນທີ / ເດືອນ</TableHead>
            <TableHead className="w-[140px] text-right">ລາຍຮັບທັງໝົດ</TableHead>
            <TableHead className="w-[120px] text-right">ລາຍຮັບແພັກເກດ</TableHead>
            <TableHead className="w-[120px] text-right">
              ລາຍຮັບຮຽນສ່ວນຕົວ
            </TableHead>
            <TableHead className="w-[140px] text-right">
              ລາຍຮັບຄ່າເຊົ່າຫ້ອງ
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={row.period}>
                <TableCell className="text-muted-foreground text-sm">
                  {formatDate(row.period)}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.totalRevenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.packageRevenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.privateLessonRevenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.roomBookingRevenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
